import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { FormGroup, FormControl } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material';

import { Workflow } from './workflow.model';
import { UsersService } from '../users/users.service';
import { ListItemAnimation } from '../shared/list-item.animation';
import { FadeInAnimation } from '../shared/fade-in.animation';
import { AuthService } from '../auth/auth.service';
import { SupportService } from 'app/shared/support.service';

@Component({
  selector: 'app-workflows',
  templateUrl: './workflows.component.html',
  styleUrls: ['./workflows.component.scss'],
  animations: [ListItemAnimation(), FadeInAnimation]
})
export class WorkflowsComponent implements OnInit {
  @Input() workflows: Workflow[] = [];
  count = 0;
  currentUser = this.authService.currentUser;
  filteredWorkflows: Workflow[] = [];
  form: FormGroup;
  loading = true;
  page = 1;
  search: string;
  splitRegex: RegExp;
  total = 0;
  supportLink: string;

  constructor(
    private authService: AuthService,
    private route: ActivatedRoute,
    private dialogRef: MatDialogRef<WorkflowsComponent>,
    private usersService: UsersService,
    private supportService: SupportService
  ) {
    this.supportLink = this.supportService.link;
  }

  get totalPages(): number { return Math.ceil(+this.total / 10); };

  ngOnInit() {
    const searchControl = new FormControl(null, []);
    searchControl.valueChanges.debounceTime(250).subscribe((value) => {
      this.search = value;
      this.page = 1;
      this.filterWorkflows();
    });

    this.form = new FormGroup({
      search: searchControl
    });

    this.filterWorkflows();
  }

  onSubmit() {
    this.filterWorkflows();
  }

  loadPage(page) {
    this.page = page;
    this.filterWorkflows();
  }

  filterWorkflows() {
    this.loading = true;
    this.splitRegex = null;
    let filtered: Workflow[];
    if (this.search != null && this.search !== '') {
      this.splitRegex = new RegExp('(\\b' + this.search.regExpEscape() + ')', 'gi');
      const regex = new RegExp('\\b' + this.search.regExpEscape(), 'i');
      filtered = this.workflows.filter((w) => regex.test(w.name));
    } else {
      filtered = this.workflows;
    }
    this.total = filtered.length;
    const start = (this.page - 1) * 10;
    const end = start + 10;
    this.filteredWorkflows = filtered.slice(start, end);
    this.count = this.filteredWorkflows.length;
    this.loading = false;
  }

  selectWorkflow(workflow) {
    this.dialogRef.close({ template: null, workflow: workflow });
  }
}



// WEBPACK FOOTER //
// ./src/app/workflows/workflows.component.ts